import { getCommonBarInfo, setCommonBarClose } from '@/api/growth';
import StudentCodeVerify from '@/components/homepage/components/PopupCreateAccount/StdCodeVerify';
import Constant from '@/constants/const';
import { PageNameV2 } from '@/constants/track';
import useSourceOfStudent from '@/hooks/source-of-student';
import useCountdown from '@/hooks/useCountDown';
import useAccount from '@/store/account';
import { getPageKey } from '@/tracks/getPageKey';
import useClickActionT2 from '@/tracks/useClickActionT2';
import useImpressionT2 from '@/tracks/useImpressionT2';
import { isWeixinBrowser } from '@/utils/common/device';
import { getLoginState } from '@/utils/common/user';
import { getCookie } from '@/utils/cookie';
import { getPathNoLangOnClient } from '@/utils/url';
import { hideLoading, showLoading, useCroppedImage } from '@weee-fe/module';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import qs from 'qs';
import { useEffect, useMemo, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { getPageEventNameV2 } from 'tracks/tracker';
import ThemeNavBarColorObserver from '@/components/common/EnkiDummyUI/ThemeNavBarColorObserver';
import useCart from '@/store/shopping/index';

import useTranslation from 'next-translate/useTranslation';
import { parsePopupLink } from '@/components/support-popup/utils';
import SupportPopup from '@/components/support-popup';

type Props = {
  cookieKey: 'landing_stamp_expires' | 'pdp_landing_stamp_expires';
  initialVisible?: boolean;
  amount?: number | string;
  onClose?: () => void;
  clickCallback?: () => void;
  _subRef?: React.MutableRefObject<HTMLDivElement>;
};

/*
3.28完成 倒计时 & text 版本迭代
countdown = null 无倒计时的模式，固定展示timer banner，只能手动关闭
type=1,2 拿end_time字段
- type = 1 带方块背景色的倒计时模式，倒计时结束自动关闭timer banner
- type = 2 无方块背景普通的文本倒计时，倒计时结束自动关闭timer banner
type=3 拿show_time字段
- type = 3 不显示倒计时，后台自动倒计时10s，倒计时结束自动关闭timer banner
*/
export default function TopCommonPromoBar(props: Props) {
  const { cookieKey, initialVisible = false, clickCallback, _subRef } = props;
  const { commonBarCopy, syncCommonBarCopy } = useAccount();
  const timeStampRef = useRef(0);
  const defaultRef = useRef(null);
  const timeBannerRef = _subRef != undefined ? _subRef : defaultRef;
  const [copyInfo, setCopyIfo] = useState<any>();
  const [visible, visibleSet] = useState(initialVisible || false);
  const [email, setEmail] = useState('');
  const router = useRouter();
  const { query, locale } = router;
  const { t, lang } = useTranslation('common');

  const isFirstLoad = useRef(true);
  const codeRef = useRef<any>(null);
  const popupRef = useRef<any>(null);
  const [popupProps, setPopupProps] = useState({});

  const { bannerImpression } = useImpressionT2();
  const { bannerClick } = useClickActionT2();
  const { getCroppedUrl, getSwitchedUrl } = useCroppedImage();

  const { checkSourceOfStudent } = useSourceOfStudent();

  const handleSpecialSet = () => {
    const domTimeBannerHeight = timeBannerRef?.current?.clientHeight;
    const stickyTop = 48 + domTimeBannerHeight;
    const domCategory = document.querySelector('#category_filter');
    if (domCategory) {
      (domCategory as HTMLElement).style.top = `${stickyTop}px`;
    }
  };

  const releaseSpecialSet = () => {
    const domPageSearch = document.querySelector('#sticky-header');
    if (domPageSearch) {
      (domPageSearch as HTMLElement).style.top = ``;
    }
    const domCategory = document.querySelector('#category_filter');
    if (domCategory) {
      (domCategory as HTMLElement).style.top = '48px';
    }
    const domToastContainerCheckout = document.querySelector('#toastContainerCheckout');
    if (domToastContainerCheckout) {
      (domToastContainerCheckout as HTMLDivElement).style.top = ``;
    }
  };

  const refreshBar = async () => {
    let postData: {
      referrer_id?: string;
      ep_partner?: string;
      channel_type?: string;
      referral_type?: string;
      user_type?: string;
    } = {
      referrer_id: getCookie(Constant.REFERRER_ID) || '',
      ep_partner: getCookie(Constant.EP_PARTNER) || '',
      channel_type: (query.channel_type as string) || '',
      referral_type: (query.referral_type as string) || ''
    };
    if (!getLoginState() && checkSourceOfStudent()) {
      postData.user_type = Constant.STUDENT_SOURCE;
    }
    const res = await getCommonBarInfo(postData);
    if (res?.result) {
      syncCommonBarCopy(res.object || {});
    }
  };

  // countdown倒计时结束 || show_time模式自动关闭
  const onAutoClose = () => {
    visibleSet(false);
    releaseSpecialSet();
    refreshBar();
  };
  // 用户主动关闭
  const onClickClose = e => {
    e.stopPropagation();
    visibleSet(false);
    releaseSpecialSet();
    clickTracking('dismiss');
    window.dispatchEvent(new CustomEvent('new-user-banner-change', { detail: { visible: false } }));
    setCommonBarClose({ bar_id: copyInfo?.id }).then(res => {
      refreshBar();
    });
    props?.onClose?.();
  };

  const clickCountDown = async e => {
    e.stopPropagation();
    clickTracking('message');
    showLoading();
    // show popup 一些活动弹窗
    const showPopup = copyInfo?.click_style === 'popup';
    if (showPopup && copyInfo?.link?.includes('support/popup-link')) {
      const popupInfo = parsePopupLink(copyInfo?.link as string);
      if (popupInfo?.popupKey) {
        setPopupProps({
          componentKey: popupInfo?.popupKey,
          url: copyInfo?.link
        });
        popupRef.current.show();
      }
      hideLoading();
      return;
    }
    // 学生验证邮箱
    if (showPopup && copyInfo?.right_cta?.type === 'button' && getLoginState()) {
      const url = copyInfo?.link;
      const _email = qs.parse(url?.split('?')?.[1]?.split('#')?.[0])?.['email'] as string;
      setEmail(_email);
      // await sendStdEmailVerify();
      codeRef.current.show();
      hideLoading();
      return;
    }
    hideLoading();
    const pageKey = getPageKey(router.asPath);
    if ((showPopup && PageNameV2.mweb_login_signup === pageKey) || isWeixinBrowser()) return;
    // 非edu且未登录用户，点击bar显示ftu popup
    if (showPopup && clickCallback) {
      clickCallback();
      return;
    }
    if (copyInfo?.link) {
      router.push(copyInfo?.link);
    }
  };

  const impressionTracking = info => {
    bannerImpression({
      co: {
        banner_id: info?.id,
        url: info?.link
      },
      mod_nm: 'promotion_bar'
    });
  };

  const clickTracking = type => {
    bannerClick({
      mod_nm: 'promotion_bar',
      co: {
        target_pos: 0,
        target_type: type,
        target_nm: copyInfo?.id
      }
    });
  };

  useEffect(() => {
    if (!commonBarCopy) return;
    if ((commonBarCopy || [])?.length > 0) {
      // 接口已返回需要显示页面 & bar信息
      const data = commonBarCopy?.[0];
      const showPages = data?.pages || [];
      const curPageKey = getPageEventNameV2(getPathNoLangOnClient()) || '';
      if (showPages?.includes(curPageKey)) {
        visibleSet(true);
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('new-user-banner-change', { detail: { visible: true } }));
        }, 30);
        setCopyIfo(data);
        impressionTracking(data);
      } else {
        visibleSet(false);
        if (visible) {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('new-user-banner-change', { detail: { visible: false } }));
          }, 30);
        }
      }
    } else {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('new-user-banner-change', { detail: { visible: false } }));
      }, 30);
      visibleSet(false);
    }
  }, [JSON.stringify(commonBarCopy)]);

  // 商品变化，刷新bar
  useEffect(() => {
    const handleCartChanged = () => {
      if (visible && copyInfo?.style === 'progress') {
        refreshBar();
      }
    };
    window.addEventListener('cart-changed', handleCartChanged);
    return () => {
      window.removeEventListener('cart-changed', handleCartChanged);
    };
  }, [visible, copyInfo?.style]);

  useEffect(() => {
    if (visible) {
      handleSpecialSet();
    }
  }, [visible]);

  if (!visible) {
    return null;
  }

  if (commonBarCopy === null) {
    return (
      <div
        ref={timeBannerRef}
        id="timeBanner"
        className={classNames('px-5 flex justify-between items-center bg-surface-100-bg', 'h-[54px] pb-1')}>
        <div className={classNames('bg-surface-200-bg', 'rounded-400 w-[160px] h-6')}></div>
        <div className={classNames('bg-surface-200-bg', 'rounded-400 w-[120px] h-6')}></div>
      </div>
    );
  }

  return (
    <div
      data-testid="wid-top-common-promo-bar"
      ref={timeBannerRef}
      id="timeBanner"
      className={classNames('min-h-[54px]', 'pl-5 pr-3 flex items-center justify-between bg-surface-100-bg')}
      style={{
        backgroundColor: copyInfo?.bg_color,
        color: copyInfo?.color,
        backgroundImage: copyInfo?.bg_img ? `url(${getCroppedUrl(copyInfo.bg_img, { renderWidth: 400 })})` : '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      onClick={clickCountDown}>
      {!!copyInfo?.icon_url && (
        <div data-testid="wid-top-common-promo-bar-icon" className="shrink-0 w-6 h-6 mr-2">
          <img
            data-testid="wid-top-common-promo-bar-icon-img"
            className="w-full"
            src={copyInfo?.icon_url}
            alt={`weee image ${copyInfo?.title?.text}`}
          />
        </div>
      )}
      {!!copyInfo?.title && (
        <div data-testid="wid-top-common-promo-bar-title" className="line-clamp-3 flex-1 mr-2">
          <div
            data-testid="wid-top-common-promo-bar-title-text"
            className={classNames(
              twMerge('enki-body-sm-strong', 'py-1', locale === Constant.LANGUAGE_ES && '!tracking-normal')
            )}
            dangerouslySetInnerHTML={{
              __html: copyInfo?.title?.text
            }}
          />
          {!!copyInfo?.title?.sub_text && (
            <div
              data-testid="wid-top-common-promo-bar-title-sub-text"
              className="enki-body-2xs pb-1"
              dangerouslySetInnerHTML={{ __html: copyInfo?.title?.sub_text }}
            />
          )}
        </div>
      )}
      {!!copyInfo?.countdown?.type && (
        <CountDownTimer
          cookieKey={cookieKey}
          data={copyInfo.countdown}
          onEnd={onAutoClose}
          syncTime={() => timeStampRef.current}
        />
      )}
      {copyInfo?.right_cta?.type === 'button' && (
        <div
          data-testid="wid-top-common-promo-bar-right-cta"
          className="enki-body-2xs px-2 py-1 rounded-full"
          dangerouslySetInnerHTML={{ __html: copyInfo?.right_cta?.title }}
          style={{ backgroundColor: copyInfo?.right_cta?.title_bg_color }}></div>
      )}
      {!!copyInfo?.close_cta?.icon_url && (
        <div className="shrink-0 px-2 py-3 -mr-2 w-5 h-5" data-testid="btn-close-promo-bar" onClick={onClickClose}>
          <img className="w-full h-full object-cover" src={getSwitchedUrl(copyInfo?.close_cta?.icon_url)} alt="Close" />
        </div>
      )}
      <StudentCodeVerify ref={codeRef} email={email} hasSend={false} />
      <SupportPopup ref={popupRef} isPopup={true} {...popupProps} />
      {visible && <ThemeNavBarColorObserver visibleColor={copyInfo?.bg_color} />}
    </div>
  );
}
interface ICountDownTimerProps extends Pick<Props, 'cookieKey'> {
  data: any;
  onEnd: () => void;
  syncTime?: (stamp: number) => void;
}
function CountDownTimer(props: ICountDownTimerProps) {
  const { cookieKey, data, onEnd, syncTime } = props;
  const { number_bg_color, number_color, title, end_time, show_time, type, server_timestamp } = data;
  const { timeString, timeStamp } = useCountdown(() => end_time as number, {
    onEnd: () => {
      onEnd();
    }
  });
  syncTime?.(timeStamp);

  useEffect(() => {
    if (type == 3) {
      // 不显示倒计时后台自动倒计时{show_time}s 结束自动关闭
      let timer = setTimeout(() => {
        onEnd();
      }, show_time || 10000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [type, show_time]);

  if (!timeString) return null;

  // 带方块背景色倒计时
  if (type == 1) {
    return (
      <div data-testid="wid-top-common-promo-bar-countdown" className="flex items-center">
        {!!title && (
          <div
            data-testid="wid-top-common-promo-bar-countdown-title"
            className="enki-body-2xs mr-1"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div data-testid="wid-top-common-promo-bar-countdown-time" className="flex items-center enki-body-2xs-strong">
          {timeString.split(':').map((item, index) => {
            return (
              <div key={index}>
                {[item[0], item[1]].map((str, sIndex) => {
                  return (
                    <span
                      data-testid="wid-top-common-promo-bar-countdown-time-number"
                      key={sIndex}
                      className={classNames(
                        'inline-block w-[15px] h-[22px] !leading-[22px] text-center ml-0.5 rounded-[5px]'
                      )}
                      style={{
                        background: number_bg_color,
                        color: number_color
                      }}>
                      {str || '0'}
                    </span>
                  );
                })}
                {index < timeString.split(':').length - 1 && (
                  <span
                    data-testid="wid-top-common-promo-bar-countdown-time-colon"
                    className={classNames('inline-block !leading-[22px]', 'ml-0.5')}
                    style={{ color: number_bg_color }}>
                    :
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // 无方块背景普通文本倒计时
  if (type == 2) {
    return (
      <div data-testid="wid-top-common-promo-bar-countdown" className="flex items-center">
        {!!title && (
          <div
            data-testid="wid-top-common-promo-bar-countdown-title"
            className="enki-body-2xs mr-1"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div
          data-testid="wid-top-common-promo-bar-countdown-time"
          className="flex items-center enki-body-2xs-strong min-w-[55px]">
          {timeString.split(':').map((item, index) => {
            return (
              <div
                data-testid="wid-top-common-promo-bar-countdown-time-item"
                key={index}
                style={{ color: number_color }}>
                {[item[0], item[1]].map((str, sIndex) => {
                  return (
                    <span data-testid="wid-top-common-promo-bar-countdown-time-item-number" key={sIndex}>
                      {str || '0'}
                    </span>
                  );
                })}
                {index < timeString.split(':').length - 1 && <span className="inline-block mx-[1px]">:</span>}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
}
